export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/48c3d350a874654b9919fc00f7ab5f35.png";